import { AlertData } from '@solvace/feature/modals/svc-modal-alert';

export enum AlertRecordState {
  Open = 1,
  InProgress = 2,
  Closed = 3,
}

export interface AlertRecordStatePill {
  label: string;
  colorClass: string;
}

export type AlertRecordData = AlertData & { actionPlanState?: AlertRecordState };

const PENDING_PILL_CLASS = 'border-st-draft bg-st-draft-tint text-st-draft';
const DONE_PILL_CLASS = 'border-st-done bg-st-done-tint text-st-done';

export const ALERT_RECORD_STATE_PILLS: Record<AlertRecordState, AlertRecordStatePill> = {
  [AlertRecordState.Open]: { label: 'Em aberto', colorClass: PENDING_PILL_CLASS },
  [AlertRecordState.InProgress]: { label: 'Em andamento', colorClass: PENDING_PILL_CLASS },
  [AlertRecordState.Closed]: { label: 'Encerrado', colorClass: DONE_PILL_CLASS },
};
